




















































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const auth = namespace('Auth');
const vote = namespace('Vote');

@Component({})
export default class Home extends Vue {
  @auth.State
  loggedIn!: boolean;

  @auth.State
  loggingIn!: boolean;

  @auth.Action
  logIn!: () => void;

  @vote.State
  totalVotes!: number;

  @vote.Action
  getTotalVotes!: () => void;

  mounted() {
    this.getTotalVotes();
  }
}
